
















































































import { Component, Vue } from "vue-property-decorator";
import {
  FiltroKitsDinamicos,
  KitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { moeda } from "@/shared/filters";
import { dateTime } from "@/shared/filters";
import { ServerPageOptions } from "@/shared/utils/datatable";

@Component({
  components: { DataTable, Tooltip },
  filters: {
    moeda,
    dateTime,
  },
})
export default class KitsDinamicos extends Vue {
  
  filtro: FiltroKitsDinamicos = {
    txtPesquisa: "",
    offset: 0,
    limit: 100,
    order: "",
  }
  
  promise: Promise<KitDinamico[]> | null = null;

  headers = [
    { value: "descricao", text: "Descrição" },
    { value: "codigoFornecedor", text: "Código do Fornecedor" },
    { value: "validoApos", text: "Válido Após" },
    { value: "validoAte", text: "Válido Até" },
    { value: "aplicaDesconto", text: "Aplica Desconto" },
    { value: "dataCriacao", text: "Data de Criação" },
    { value: "dataAlteracao", text: "Data de Alteração" },
    { value: "excluido", text: "Excluído" },
    { value: "preco", text: "Preço" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.filtro.txtPesquisa = "";
  }

  fetchKitsDinamicos(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = KitsDinamicosService.listarKitsDinamicos(this.filtro);
  }

  alterar(item: KitDinamico) {
    if (item.idKitDinamico) {
      this.$router.push({
        name: "alterar-kitdinamico",
        params: { id: item.idKitDinamico },
      });
    }
  }

  duplicar(item: KitDinamico) {
    if (item.idKitDinamico) {
      this.$router.push({
        name: "novo-kitdinamico",
        query: {
          idCopia: item.idKitDinamico,
        },
      });
    }
  }

  novo() {
    this.$router.push({
      name: "novo-kitdinamico",
    });
  }
}
